/**
 * Fraction options for measurement inputs. Mirrors the upload wizard's
 * MeasurementField component so the wizard and edit-object UIs offer the
 * same choices. Imperial inches use 1/16ths; feet use coarser fractions.
 */
export const INCH_FRACTIONS = [
  '1/16',
  '1/8',
  '3/16',
  '1/4',
  '5/16',
  '3/8',
  '7/16',
  '1/2',
  '9/16',
  '5/8',
  '11/16',
  '3/4',
  '13/16',
  '7/8',
  '15/16',
] as const;

export const FEET_FRACTIONS = ['1/4', '1/3', '1/2', '2/3', '3/4'] as const;

export const unitSupportsFractions = (unit: string | undefined | null): boolean =>
  unit === 'inches' || unit === 'feet';

export const getFractionOptions = (
  unit: string | undefined | null,
): ReadonlyArray<string> => {
  if (unit === 'feet') return FEET_FRACTIONS;
  if (unit === 'inches') return INCH_FRACTIONS;
  return [];
};
